<template>
  <!-- 课程上传 -->
  <div class="Uploadpagem">
    <div class="box">
      <div class="box-ceter">
        <h4 class="h4size">知识科普 > 论文编辑</h4>
        <div class="top">
          <div class="top-Major">
            <p>科普类型:</p>
            <el-radio-group
              :disabled="$route.params.id != undefined"
              v-model="radio2"
              size="mini"
              @change="selectSp"
            >
              <el-radio-button label="文章"></el-radio-button>
              <el-radio-button label="视频"></el-radio-button>
            </el-radio-group>
          </div>
          <div class="top-Major">
            <p>科普分类:</p>
            <el-radio-group
              :disabled="$route.params.id != undefined"
              v-model="radio1"
              size="mini"
            >
              <!-- <el-radio-button label="全部"></el-radio-button> -->
              <el-radio-button
                v-for="item in Majorcategories"
                :key="item.id"
                :label="item.sort"
              ></el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div v-show="radio2 === '文章'">
          <div class="wzbj">
            <div style="width: 100%">
              <div style="display: flex; align-items: center">
                <span style="width: 120px; font-size: 18px"> 文章标题：</span>
                <el-input
                  type="text"
                  v-model="title"
                  placeholder="请输入标题"
                />
              </div>
              <EditorBar
                :isClear="isClear"
                @change="(val) => changeFWB(val)"
                :value="detail"
              ></EditorBar>
            </div>
            <div class="wzzs">
              <div class="searchbox">
                <el-input placeholder="请输入内容" size="mini" v-model="name">
                </el-input>
                <el-button
                  class="appdsa"
                  @click="getSelaide()"
                  v-preventReClick="3000"
                  round
                  >搜索</el-button
                >
              </div>
              <div class="sclb" v-if="Plain == ''">素材列表</div>
              <div
                class="sclb"
                style="color: #4ccaff; cursor: pointer"
                v-else
                @click="Plain = ''"
              >
                返回列表
              </div>
              <div style="padding: 20px" v-if="Plain == ''">
                <ul style="height: 880px">
                  <li
                    class="change"
                    v-for="(item, index) in PlainList"
                    :key="item.id"
                    @click="Jumpfordetails(item)"
                  >
                    <div class="chaP" align="left">
                      {{ index + 1 }}.{{ item.name }}
                    </div>
                  </li>
                </ul>
              </div>
              <div
                v-else
                style="
                  padding: 5px;
                  font-size: 13px;
                  line-height: 23px;
                  height: 960px;
                  overflow-y: scroll;
                "
                v-html="Plain"
              ></div>
              <div
                style="
                  position: absolute;
                  padding-left: 20px;
                  padding-right: 20px;
                  cursor: pointer;
                "
              >
                <span @click="goPage('上一页')">上一页</span>
                <span style="margin-left: 190px" @click="goPage('下一页')"
                  >下一页</span
                >
              </div>
            </div>
          </div>
          <div style="text-align: center; margin-top: 20px">
            <!-- <el-button class="sch" type="danger" :disabled="sfjy"
              >删除</el-button
            > -->
            <el-button
              class="lasez"
              type="primary"
              @click="ArticleSaving('保存')"
              :disabled="sfjy"
              >保存</el-button
            >
            <el-button
              class="lasez"
              type="primary"
              @click="ArticleSaving('提交')"
              :disabled="sfjy"
              >提交审核</el-button
            >
          </div>
        </div>

        <div v-show="radio2 === '视频'">
          <div class="Uploadarea">
            <el-upload
              class="upload-demo"
              drag
              action="#"
              :auto-upload="false"
              :on-change="picthandleChange"
              :show-file-list="false"
              :disabled="
                tepslat.name.length != 0 && $route.params.id != undefined
              "
            >
              <div class="sctsd">
                <i class="iconfont gos-24gf-folderOpen gos"></i>
              </div>
              <el-button
                style="
                  width: 99px;
                  margin-top: 20px;
                  height: 28px;
                  background: #4ccaff;
                  border-radius: 6px;
                  padding: 0px;
                  font-size: 12px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #ffffff;
                "
                ><em>点击上传</em></el-button
              >
              <div class="el-upload__text">
                <div class="ssra1" style="margin-bottom: 15px; font-size: 14px">
                  也可以拖拽倒这里上传
                </div>
                <div class="ssra2">
                  支持 avi, rmvb, rm, flash, mp4, mid, 3GP等格式
                </div>
                <div class="ssra3">注意:视频大小超过500M</div>
              </div>
              <!-- <div class="el-upload__tip" slot="tip">
              只能上传jpg/png文件，且不超过500kb
            </div> -->
            </el-upload>
            <img :src="imageUrl" alt="" />
          </div>
          <div class="nav-oad">
            <div style="display: flex">
              <h4 class="nav-upload">上传列表</h4>
              <span>请于上传之日起7天内提交审核，否则草稿将被删除</span>
            </div>

            <el-button type="primary" @click="pahsires()">查看已保存</el-button>
          </div>
          <ul>
            <el-form
              v-for="(item, index) in tepslat.name"
              :inline="true"
              :model="item"
              :rules="rules"
              :ref="`formInline`"
              :key="index"
              class="demo-form-inline"
            >
              <li class="Draftbox">
                <div>
                  <div class="Draftbox_left">
                    <div class="certer">
                      <!-- <el-form-item label="课程系列名称" size="mini" prop="name">
                  <el-select
                    v-model="item.name"
                    placeholder="请选择文件类型"
                  >
                    <el-option  v-for=" item in Majorcategories" :key="item.id"
                    :label="item.name" :value="item.name"></el-option>
                  </el-select>
                </el-form-item> -->
                      <el-form-item label="课程标题" size="mini" prop="name">
                        <el-input
                          v-model="item.name"
                          placeholder="请输入文件标题"
                        ></el-input>
                      </el-form-item>

                      <el-form-item label="选择分类" size="mini" prop="sort">
                        <el-select
                          v-model="item.sort"
                          placeholder="请选择文件类型"
                          :disabled="$route.params.id != undefined"
                        >
                          <el-option
                            v-for="item in Majorcategories"
                            :key="item.id"
                            :label="item.sort"
                            :value="item.sort"
                          ></el-option>
                        </el-select>
                      </el-form-item>

                      <!-- <el-form-item label="学习目标" size="mini" prop="xxmb">
                  <el-input
                  type="textarea"
                  :autosize="{ minRows: 5, maxRows: 5}"
                  v-model="item.xxmb"
                  placeholder="请输入文件标题"
                  ></el-input>
                  </el-form-item> -->
                    </div>
                    <div class="Draftbox_rist">
                      <video
                        :src="http + item.video"
                        controls
                        style="
                          width: 181px;
                          height: 110px;
                          opacity: 0.8;
                          border-radius: 6px;
                        "
                      ></video>
                      <el-upload
                        class="uploader1"
                        action="1"
                        :show-file-list="false"
                        :on-change="
                          (file, fileList) => {
                            beforeAvatarUpload(file, fileList, index);
                          }
                        "
                      >
                        <img
                          v-if="item.picture"
                          :src="item.picture"
                          style="width: 181px; height: 105px"
                          class="avatar"
                        />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>

                        <img
                          v-if="item.picture"
                          class="delista"
                          style="width: 20px; height: 20px"
                          src="../../assets/delites.jpg"
                          alt=""
                        />
                      </el-upload>

                      <!-- <p>文件名称</p>
                  <el-button
                    class="lasez"
                    type="primary"
                    @click="submitForm(item)"
                    >更换视频</el-button
                  > -->
                    </div>
                  </div>
                  <div class="Draftbox_rist_bottom">
                    <el-form-item label="课程概述" size="mini" prop="kcjs">
                      <wangEnduitcopy
                        :isClear="isClear"
                        @blur="question(index)"
                        @change="(val) => change(val, index)"
                        :value="item.content"
                      ></wangEnduitcopy>
                      <!-- <editor-bar
                      :isClear="isClear"
                      @change="change"
                      @blur="question"
                      :value="item.kcjs"
                    ></editor-bar> -->
                      <!-- <el-input
                      type="textarea"
                      :autosize="{ minRows: 5, maxRows: 5 }"
                      v-model="item.kcjs"
                      placeholder="请输入文件标题"
                    ></el-input> -->
                    </el-form-item>
                  </div>
                </div>
                <div class="right-bottom">
                  <el-button
                    class="sch"
                    type="danger"
                    @click="delmaterial(item)"
                    >删除</el-button
                  >
                  <el-button
                    class="lasez"
                    type="primary"
                    @click="submitForm('formInline', index)"
                    >保存</el-button
                  >
                  <el-button
                    class="lasez"
                    type="primary"
                    @click="Fileupload('formInline', index)"
                    >提交视频</el-button
                  >
                </div>
              </li>
            </el-form>
          </ul>
          <div class="boytrtr">
            <!-- <el-button type="primary" @click="Alltheupload('formInline')"
              >上传全部</el-button
            > -->
            <el-pagination
              class="spage"
              prev-text="上一页"
              next-text="下一页"
              @current-change="handleCurrentChangess"
              background
              :page-size="tepage.rows"
              layout="prev, pager, next"
              :total="tepage.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// insmaterial
import wangEnduitcopy from "../../components/wangEnduitcopy.vue";
import EditorBar from "../../components/wangEnduit.vue";
import {
  selsortMu,
  seluseritem,
  insitme,
  upditem,
  upditemsp,
  delitem,
  selaide,
  seltask,
  insknow,
  selknow,
  updknow,
  updatetaskuser,
} from "@/api/patient";
import { delknow } from "../../api/patient";

export default {
  components: {
    wangEnduitcopy,
    EditorBar,
  },
  data() {
    return {
      isClear: false,
      tepage: {
        page: 1,
        rows: 3,
        total: 100,
      },
      tepslat: { name: "" },
      http: this.$store.state.https,
      Thepicture: "",
      dialogImageUrl: "",
      imageUr2: "",
      dialogVisible: false,
      // disabled: false,
      imageUrl: "",
      formInline: {
        region: "",
        user: "",
        regiosnss: "",
      },
      width: "21321",
      height: "",
      Majorcategories: "",
      id: this.$store.state.user.id,
      rules: {
        name: [{ required: true, message: "请输入课程标题", trigger: "blur" }],
        sort: [{ required: true, message: "请选择分类", trigger: "blur" }],
        // kcjs: [{ required: true, message: "请输入课程概述", trigger: "blur" }],
      },

      radio1: "",
      radio2: "文章",
      detail: "",
      detail1: "",
      PlainList: [],
      Plain: "",
      name: "",
      PlainPage: 1,
      totalPage: 0,
      title: "",
      dataKP: [],
      sfjy: false,
    };
  },
  created() {
    // this.id = this.$store.state.user.
    this.selsortis();
    this.getSelaide();
    if (this.$route.params.id) {
      this.getUserrw();
    }
  },
  methods: {
    checkContent(rule, value, callback, i) {
      if (this.tepslat.name[i].kcjs == undefined) {
        callback(new Error("请输入课程概述"));
      } else callback();
    },
    selectSp(val) {
      if (val == "视频") {
        this.selmatersp();
      }
    },
    // 列表
    selmatersp() {
      var data = new FormData();
      data.append("page", this.tepage.page);
      data.append("rows", this.tepage.rows);
      data.append("phone", this.$store.state.user.phone);
      data.append("sorts", "视频");
      data.append("status", "已保存");
      selknow(data).then((res) => {
        console.log(res);
        this.tepslat.name = res.records;
        for (let i = 0; i < this.tepslat.name.length; i++) {
          if (
            this.tepslat.name[i].picture !== "" &&
            this.tepslat.name[i].picture !== null
          ) {
            this.tepslat.name[i].picture =
              this.$store.state.https + this.tepslat.name[i].picture;
          }
        }
        this.tepage.total = res.totalCount;
      });
    },
    // 列表
    selmaterialis(type) {
      var data = new FormData();
      data.append("page", this.tepage.page);
      data.append("rows", this.tepage.rows);
      data.append("phone", this.$store.state.user.phone);
      if (this.$route.params.id) {
        data.append("tid", this.$route.params.id);
      }
      selknow(data).then((res) => {
        if (res.records[0].sorts == "视频") {
          this.tepslat.name = res.records;
          for (let i = 0; i < this.tepslat.name.length; i++) {
            if (
              this.tepslat.name[i].picture !== "" &&
              this.tepslat.name[i].picture !== null
            ) {
              this.tepslat.name[i].picture =
                this.$store.state.https + this.tepslat.name[i].picture;
            }
          }
        } else {
          this.dataKP = res.records;
          if (this.dataKP.length !== 0) {
            this.radio2 = res.records[0].sorts;
            this.radio1 = res.records[0].sort;
            this.detail = res.records[0].content;
            this.title = res.records[0].name;
            if (res.records[0].status !== "已保存") {
              this.sfjy = true;
            }
          }
        }
      });
    },
    // 文章保存
    ArticleSaving(type) {
      if (this.detail1 == "" || this.title == "")
        return this.$message({
          showClose: true,
          message: "请将内容填写完整",
          type: "warning",
        });
      var data = new FormData();
      if (this.$route.params.id) {
        data.append("tid", this.$route.params.id);
      }
      data.append("phone", this.$store.state.user.phone);
      data.append("name", this.title);
      data.append("content", this.detail1);
      data.append("sort", this.radio1);
      data.append("sorts", this.radio2);
      if (type == "保存") {
        data.append("status", "已保存");
      }
      if (type == "提交") {
        data.append("status", "待审核");
      }
      if (this.dataKP.length == 0) {
        var imageRegex = /(https?:\/\/.*?\.(?:jpg|jpeg|png|gif)(?:\?.*)?)/gi;
        var match = imageRegex.exec(this.detail1);
        if (match !== null) {
          data.append("picture", match[0]);
        }
        insknow(data).then((res) => {
          if (res.code == "OK") {
            if (type == "提交" && this.$route.params.id) {
              var data1 = new FormData();
              data1.append("tid", this.$route.params.id);
              data1.append("phone", this.$store.state.user.phone);
              data1.append("status", "已提交");
              updatetaskuser(data1).then((res) => {
                console.log(res);
              });
            }

            this.$message({
              showClose: true,
              message: type + "成功",
              type: "success",
            });
            this.$router.go(-1);
          } else {
            this.$message({
              showClose: true,
              message: type + "失败",
              type: "error",
            });
          }
        });
      } else {
        data.append("id", this.dataKP[0].id);
        updknow(data).then((res) => {
          if (res.code == "OK") {
            if (type == "提交" && this.$route.params.id) {
              var data1 = new FormData();
              data1.append("tid", this.$route.params.id);
              data1.append("phone", this.$store.state.user.phone);
              data1.append("status", "已提交");
              updatetaskuser(data1).then((res) => {
                console.log(res);
              });
            }
            this.$message({
              showClose: true,
              message: type + "成功",
              type: "success",
            });
            this.$router.go(-1);
          } else {
            this.$message({
              showClose: true,
              message: type + "失败",
              type: "error",
            });
          }
        });
      }
    },

    //获取任务信息
    getUserrw() {
      const data = new FormData();
      data.append("id", this.$route.params.id);
      data.append("page", 1);
      data.append("rows", 1);
      seltask(data).then((res) => {
        this.radio2 = res.sta;
        this.radio1 = res.sort;
        this.selmaterialis();
      });
    },
    goPage(type) {
      if (type == "下一页") {
        if (this.PlainPage == this.totalPage)
          return this.$message("已经是最后一页了");
        this.PlainPage = this.PlainPage + 1;
        this.getSelaide();
      } else {
        if (this.PlainPage == 1) return this.$message("已经是第一页了");
        this.PlainPage = this.PlainPage - 1;
        this.getSelaide();
      }
    },
    //查看详情
    Jumpfordetails(item) {
      this.Plain = item.content;
    },
    getSelaide() {
      const data = new FormData();
      data.append("status", "已发布");
      if (this.name) {
        data.append("name", this.name);
      }
      data.append("page", this.PlainPage);
      data.append("rows", 25);
      selaide(data).then((res) => {
        this.PlainList = res.records;
        this.totalPage = res.totalPage;
      });
    },
    // 选择
    selitemis() {},
    changeFWB(val) {
      this.detail1 = val;
    },
    change(val, i) {
      console.log(val, i);
      this.tepslat.name[i].content = val;
    },
    question() {
      // validateField表单的字段验证的方法
      this.$refs.tepslat.validateField("content");
      console.log(this.$refs.tepslat.validateField("content"));
    },
    delites() {},
    // 封面图上传
    beforeAvatarUpload(file, fileList, item) {
      var a = false;
      console.log(file);
      const isJPG =
        file.raw.type === "image/jpeg" ||
        file.raw.type === "image/png" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 2;
      console.log(isJPG, isLt2M);
      if (isJPG == false || isLt2M == false) {
        this.$message.error("封面图只能是 JPG,PNG 格式!封面图大小不得超过2MB!");
      } else {
        this.tepslat.name[item].picture = URL.createObjectURL(file.raw);
        a = true;
      }
      if (a) {
        this.tepslat.name[item].picturefile = file.raw;
      }
      this.$forceUpdate();
      console.log(this.tepslat);
    },
    // 全部上传
    async Alltheupload(formName) {
      // debugger;
      var date = new Date();
      const createDate = this.$moment(date).format("YYYY-MM-DD");
      var s = 0;
      var a = [];
      for (let i = 0; i < this.tepslat.name.length; i++) {
        if (
          this.tepslat.name[i].sort !== "" &&
          this.tepslat.name[i].sort !== null &&
          this.tepslat.name[i].name !== "" &&
          this.tepslat.name[i].name !== null &&
          this.tepslat.name[i].kcjs !== "" &&
          this.tepslat.name[i].kcjs !== null &&
          this.tepslat.name[i].sp !== "" &&
          this.tepslat.name[i].sp !== null &&
          this.tepslat.name[i].wslzyzd !== "" &&
          this.tepslat.name[i].wslzyzd !== null
        ) {
          var data = new FormData();
          data.append("id", this.tepslat.name[i].id);
          data.append("sort", this.tepslat.name[i].sort);
          data.append("name", this.tepslat.name[i].name);
          data.append("kcjs", this.tepslat.name[i].kcjs);
          data.append("sp", this.tepslat.name[i].sp);
          if (
            this.tepslat.name[i].tp1 !== "" &&
            this.tepslat.name[i].tp1 !== null
          ) {
            data.append("tp1", this.tepslat.name[i].tp1);
          } else {
            data.append("tp", this.tepslat.name[i].tp);
          }
          data.append("scrq", createDate);
          data.append("jg", "免费");
          data.append("userid", this.$store.state.user.id);
          await upditem(data).then((res) => {
            a.push(this.tepslat.name[i].id);
            if (i === this.tepslat.name.length - 1) {
              s = 1;
            }
          });
        } else {
          this.$message({
            message: "请填写完整后，并保存成功后点击全部提交",
            type: "warning",
          });
          return;
        }
      }
      if (s == 1) {
        var data = new FormData();
        data.append("ids", a);
        data.append("status", "待发布");
        upditemsp(data).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
            this.selmaterialis();
          }
        });
      }
    },

    pahsires() {
      this.$store.commit("Stateofsss", "已保存");
      this.$router.push("/Materialtoupload");
    },
    // 删除
    delmaterial(item) {
      var data = new FormData();
      data.append("id", item.id);
      delknow(data).then((res) => {
        if (res.code === "OK") {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          });
          if (this.$route.params.id) {
            this.selmaterialis();
          } else {
            this.selmatersp();
          }
        }
      });
    },
    // 文件上传
    Fileupload(formName, i) {
      this.$refs[formName][i].validate((valid) => {
        if (valid) {
          if (
            this.tepslat.name[i].content == "" ||
            this.tepslat.name[i].content == null ||
            this.tepslat.name[i].content == undefined
          )
            return this.$message({
              message: "请填写完整",
              type: "warning",
            });
          if (
            this.tepslat.name[i].picture !== "" &&
            this.tepslat.name[i].picture !== null
          ) {
            this.submitForsm(formName, i);
            // var data = new FormData();
            // data.append("ids", this.tepslat.name[i].id);
            // data.append("status", "待发布");
            // upditemsp(data).then((res) => {
            //   if (res.code === "OK") {
            //     this.$message({
            //       showClose: true,
            //       message: res.msg,
            //       type: "success",
            //     });
            //     this.selmaterialis();
            //   }
            // });
          } else {
            this.$message({
              message: "请选择一张图片作为视频的封面",
              type: "warning",
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 文件保存
    submitForm(formName, i) {
      this.$refs[formName][i].validate((valid) => {
        if (valid) {
          if (
            this.tepslat.name[i].content == "" ||
            this.tepslat.name[i].content == null ||
            this.tepslat.name[i].content == undefined
          )
            return this.$message({
              message: "请填写完整",
              type: "warning",
            });
          if (
            this.tepslat.name[i].picture !== "" &&
            this.tepslat.name[i].picture !== null
          ) {
            var data = new FormData();
            data.append("id", this.tepslat.name[i].id);
            data.append("name", this.tepslat.name[i].name);
            data.append("sort", this.tepslat.name[i].sort);
            data.append("content", this.tepslat.name[i].content);
            if (
              this.tepslat.name[i].picturefile !== "" &&
              this.tepslat.name[i].picturefile !== null
            ) {
              data.append("picturefile", this.tepslat.name[i].picturefile);
            }
            updknow(data).then((res) => {
              if (res.code == "OK") {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
              }
            });
          } else {
            this.$message({
              message: "请选择一张图片作为视频的封面",
              type: "warning",
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitForsm(formName, i) {
      var data = new FormData();
      data.append("id", this.tepslat.name[i].id);
      data.append("name", this.tepslat.name[i].name);
      data.append("content", this.tepslat.name[i].content);
      data.append("status", "待审核");
      if (
        this.tepslat.name[i].picturefile !== "" &&
        this.tepslat.name[i].picturefile !== null
      ) {
        data.append("picturefile", this.tepslat.name[i].picturefile);
      }
      updknow(data).then((res) => {
        if (res.code == "OK") {
          var data1 = new FormData();
          data1.append("tid", this.$route.params.id);
          data1.append("phone", this.$store.state.user.phone);
          data1.append("status", "已提交");
          updatetaskuser(data1).then((res) => {
            console.log(res);
          });
          this.selmaterialis();
          this.$message({
            showClose: true,
            message: "提交成功",
            type: "success",
          });
          this.$router.go(-1);
        }
      });
    },
    // 筛选大类
    selsortis() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 100);
      data.append("name", "知识科普");
      selsortMu(data).then((res) => {
        this.Majorcategories = res;
        this.radio1 = res[0].sort;
      });
    },

    // // 素材图片尺寸
    // insmaterial (file) {
    //   const img = new Image()
    //   img.src = URL.createObjectURL(file.raw)
    //   return new Promise((resolve, reject) => {
    //     img.onload = () => {
    //       sessionStorage.setItem('height', img.height)
    //       sessionStorage.setItem('width', img.width)
    //       resolve(true)
    //     }
    //   })
    // },
    // 视频尺寸
    getVideoMsg(file) {
      return new Promise((resolve) => {
        const videoElement = document.createElement("video");
        videoElement.src = URL.createObjectURL(file);
        videoElement.addEventListener("loadedmetadata", () => {
          resolve({
            duration: videoElement.duration,
            height: videoElement.videoHeight,
            width: videoElement.videoWidth,
          });
        });
      });
    },
    // 图片参数
    async picthandleChange(file, fileList) {
      console.log(file);
      // if (
      //   file.raw.type === 'image/png' ||
      //   file.raw.type === 'image/jpg' ||
      //   file.raw.type === 'image/jpeg' ||
      //   file.raw.type === 'image/gif'
      // ) {
      //   // await this.insmaterial(file)
      // }
      // if (file.raw.type === 'video/mp4') {
      //   await this.getVideoMsg(file.raw).then(videoinfo => {
      //     sessionStorage.setItem('sheight', videoinfo.height)
      //     sessionStorage.setItem('swidth', videoinfo.width)
      //   })
      // }
      // const isJPG =
      const isJPG = file.size / 1024 / 1024 < 500;
      const isLt2M = file.raw.type === "video/mp4";

      console.log(isLt2M);
      // if (!isJPG) {
      //   this.$message({
      //     showClose: true,
      //     message: '上传图片或视频只能是 png/jpg/jpeg/gif/mp4 格式!',
      //     type: 'error'
      //   })
      // }

      if (isLt2M === true && isJPG === true) {
      } else {
        this.$message({
          showClose: true,
          message: "只能上传视频类型，上传视频,视频大小不能超过500MB!",
          type: "error",
        });
      }

      if (isLt2M) {
        // var date = new Date();
        // const createDate = this.$moment(date).format("YYYY-MM-DD");
        var data = new FormData();
        data.append("videofile", file.raw);
        data.append("sort", this.radio1);
        data.append("sorts", this.radio2);
        data.append("phone", this.$store.state.user.phone);
        if (this.$route.params.id) {
          data.append("tid", this.$route.params.id);
        }
        // data.append("jg", "免费");
        data.append("status", "已保存");
        // data.append("kcjs", "");
        await insknow(data).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: "上传成功",
              type: "success",
            });
            if (this.$route.params.id) {
              this.selmaterialis();
            } else {
              this.selmatersp();
            }
          } else {
            return false;
          }
        });
      }
    },
    handleCurrentChangess(val) {
      this.tepage.page = val;
      this.selmaterialis();
    },
  },
};

// function fileChoosed (event) {
//   console.log('aa')
//   const file = event.target.files[0]
//   const fileName = file.name
//   const img = document.getElementById('a')
//   const fr = new FileReader()
//   // const ts = this
//   fr.addEventListener('load', () => {
//     const blob = 'a'
//     console.log(fileName, img, blob) // 这里能获取到三个变量
//     img.onload = () => { // 不建议在浏览器里直接用箭头函数，支持不好
//       debugger
//       console.log(fileName, img, blob)
//       //  经过测试是可以打印这三个变量的
//     }
//     img.src = fr.result
//   })
//   fr.readAsDataURL(file)
// }
</script>
<style lang="scss" scoped>
.Uploadpagem {
  width: 100%;
  background: #ffffff;
  //   height: 100%;
  margin-top: 4px;
  box-shadow: 0px 0px 3px 4px rgba(6, 0, 1, 0.07);
  .box {
    width: 1090px;
    min-height: 1200px;
    text-align: left;
    margin: 0 auto;
    padding-top: 20px;
    .box-ceter {
      padding: 0 38px;
      padding-bottom: 78px;

      .wzbj {
        display: flex;
        .wzzs {
          width: 304px;
          border: 1px solid #ededed;
          .searchbox {
            width: 245px;
            line-height: 30px;
            margin-left: 20px;
            margin-top: 18px;
            ::v-deep .el-input__inner {
              height: 30px;
              border-top-left-radius: 15px;
              border-bottom-left-radius: 15px;
              border-top-right-radius: 15px;
              border-bottom-right-radius: 15px;
            }
            ::v-deep .el-input-group__append {
              margin-left: 100px;
              // line-height: 30px;
              border: 0px;
              background: #fff;
            }
          }
          .appdsa {
            position: relative;
            left: 180px;
            top: -30px;
            padding: 0px;
            width: 70px;
            height: 29.5px;
            background: #4ccaff;
            border-left: 0px solid;
            border-radius: 15px;
            color: #fff;
          }
          .sclb {
            width: 285px;
            height: 38px;
            background: #e8e8e8;
            line-height: 38px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            padding-left: 20px;
          }
          ul {
            .change:hover {
              font-size: 16px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #4ccaff;
              // margin-top: 20px;

              .dateof {
                color: #4ccaff;
              }
              p {
                color: #4ccaff;
              }
            }

            li {
              line-height: 34px;
              cursor: pointer;
              display: flex;

              .dateof {
                margin-left: 25px;
                font-size: 16px;
                font-family: SourceHanSansCN-Regular;
                font-weight: 400;
                color: #1e1e1e;
                margin-right: 19px;
                white-space: nowrap;
              }
              img {
                width: 19px;
                height: 19px;
                margin-right: 18px;
                // z-index:10
              }
              .chaP {
                color: #1e1e1e;
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 260px;
              }
              .chaP:hover {
                color: #4ccaff;
              }
            }

            .dashed {
              position: relative;
              left: 10px;
              top: -10px;
              height: 40px;
              border: 1px dashed #bfbfbf;
            }
          }
        }
      }

      .top {
        .top-Major {
          padding-top: 16px;
          padding-bottom: 15px;
          width: 100%;
          // height: 60px;
          line-height: 30px;
          display: flex;
          text-align: left;
          border-bottom: 1px solid #f3f3f3;
          p {
            height: 30px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            margin-right: 21px;
          }
          .el-radio-group {
            min-height: 100%;
            .el-radio-button {
              ::v-deep .el-radio-button__inner {
                width: 79px;
                padding: 0px;
                text-align: center;
                height: 30px;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                border: 0px solid;
                line-height: 30px;
                border-radius: 14px;
              }
              ::v-deep
                .el-radio-button__orig-radio:checked
                + .el-radio-button__inner {
                width: 79px;
                height: 30px;
                border-radius: 14px;
                background: #4ccaff;

                color: #fff;
                box-shadow: -1px 0 0 0 #4ccaff;
              }
            }
          }
        }
      }
      .Uploadarea {
        width: 1042px;
        height: 397px;
        background: #ffffff;
        border: 1px solid #ededed;
        text-align: center;
        padding-top: 35px;
        .upload-demo {
          width: 1011px;
          height: 363px;
          background: #f6f6f6;
          margin: 0 auto;
          ::v-deep .el-upload {
            width: 1011px;
            height: 363px;
            background: #f6f6f6;
            .el-upload-dragger {
              width: 1011px;
              height: 363px;
              background: #f6f6f6;
              .el-upload__text {
                font-size: 12px;
                margin-top: 20px;
                color: #666666;
                .ssra2 {
                  font-size: 13px;
                  margin: 10px 0;
                }
              }
            }
          }
        }
      }
    }
  }
}

.h4size {
  height: 12px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #bdbdbd;
  margin-bottom: 21px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 1011px;
  height: 363px;
  background: #f6f6f6;
  line-height: 363px;
  text-align: center;
}
.avatar {
  width: 1011px;
  height: 363px;
  background: #f6f6f6;
  display: block;
}
.nav-oad {
  margin-top: 40px;
  margin-bottom: 28px;
  display: flex;
  justify-content: space-between;
  .nav-upload {
    height: 22px;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }
  span {
    margin-left: 10px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    line-height: 32px;
  }
  .el-button {
    padding: 0px;
    text-align: center;
    width: 99px;
    height: 28px;
    background: #4ccaff;
    border-radius: 6px;
    line-height: 30px;
    border: 0;
  }
}
.Draftbox {
  flex-direction: column;
  display: flex;
  width: 1000px;
  min-height: 554px;
  background: #ffffff;
  border: 1px solid #ededed;
  //   line-height: 190px;

  img {
    width: 246px;
    height: 150px;
    opacity: 0.8;
    border-radius: 6px;
  }
  .Draftbox_left {
    margin-top: 47px;
    width: 100%;
    display: flex;
    .certer {
      margin-left: 25px;
      width: 50%;
      display: flex;
      flex-direction: column;
      ::v-deep .el-form-item {
        margin-bottom: 29px;
        .el-form-item__label {
          width: 96px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          line-height: 34px;
        }
        .el-form-item__content {
          width: 350px;
          .el-select {
            width: 100%;
          }
          .el-input {
            width: 100%;
          }
          .el-textarea {
            width: 100%;
          }
        }
      }
    }
    .Draftbox_rist {
      width: 40%;
      display: flex;
      justify-content: space-around;

      // p {
      //   margin-top: 10px;
      //   height: 16px;
      //   font-size: 14px;
      //   font-family: Source Han Sans CN;
      //   font-weight: 400;
      //   color: #333333;
      // }
      // .lasez {
      //   margin-top: 32px;
      //   padding: 0;
      //   width: 99px;
      //   height: 28px;
      //   border-radius: 6px;
      //   border: 0;
      //   background: #4ccaff;
      // }
      .lasez:hover {
        background: #4ccaffc9;
      }
    }
  }

  .right-bottom {
    margin-top: 10px;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    // flex-direction: column;
    button {
      //   margin: 0px;
      padding: 0;
      width: 99px;
      height: 28px;
      border-radius: 6px;
      border: 0;
    }
    .lasez {
      background: #4ccaff;
    }
    .lasez:hover {
      background: #4ccaffc9;
    }
    .sch:hover {
      background: #f56c6cc7;
    }
  }
}
ul {
  padding-bottom: 50px;
  min-height: 526px;
}
.boytrtr {
  text-align: center;
  //  margin-bottom:78px ;
  .el-button {
    padding: 0;
    width: 99px;
    height: 28px;
    background: #4ccaff;
    border-radius: 6px;
    border: 0px;
    margin-bottom: 20px;
  }
}
.el-button:hover {
  background: #4ccaffc9;
}
.gos {
  padding: 27px;
  font-size: 37px;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  color: #4ccaff;
}
.sctsd {
  margin-top: 76px;
  margin-bottom: 20px;
}
.ssra3 {
  font-size: 12px;
}
::v-deep.uploader1 {
  padding-top: 5px;
  width: 181px;
  height: 105px;
  .el-upload {
    width: 181px;
    height: 105px;
    .el-icon-plus {
      width: 181px;
      height: 105px;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 181px;
      height: 105px;
      line-height: 105px;
      text-align: center;
    }
    .delista {
      position: relative;
      top: -113px;
      right: -90px;
      z-index: 100;
    }
  }
}
.Draftbox_rist_bottom {
  width: 100%;
  margin-top: 10px;

  ::v-deep .el-form-item {
    width: 100%;

    margin-left: 25px;
    .el-form-item__label {
      width: 96px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 34px;
    }
    .el-form-item__content {
      width: 80%;
    }
  }
}
// 适配手机端
@media (max-width: 768px) {
  .Uploadpagem {
    .box {
      width: 100vw;
      .box-ceter {
        padding: 0 10px;
        padding-bottom: 78px;

        .wzbj {
          display: block;
          .wzzs {
            width: 95vw;
            .searchbox {
              width: 80vw;
            }
            .appdsa {
              left: 65vw;
            }
            .sclb {
              width: 90vw;
            }
          }
        }

        .top {
          .top-Major {
            width: 95vw;
            flex-shrink: 0; /* 防止项目在空间不足时缩小 */
            white-space: nowrap; /* 确保项目不换行 */
            /* 样式调整，根据需要设置宽度、间距等 */
            margin-right: 10px;
            /* 其他样式 */
            overflow-x: auto;
          }
        }
        .Uploadarea {
          width: 95vw;
          .upload-demo {
            width: 90vw;
            ::v-deep .el-upload {
              width: 90vw;
              .el-upload-dragger {
                width: 90vw;
              }
            }
          }
        }
      }
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 95vw;
    height: 363px;
    background: #f6f6f6;
    line-height: 363px;
    text-align: center;
  }
  .avatar {
    width: 95vw;
    height: 363px;
    background: #f6f6f6;
    display: block;
  }
  .nav-oad {
    display: flex;
    .nav-upload {
      width: 120px;
    }
    span {
      display: none;
    }
  }
  .Draftbox {
    flex-direction: column;
    display: block;
    width: 95vw;
    img {
      width: 246px;
      height: 150px;
      opacity: 0.8;
      border-radius: 6px;
    }
    .Draftbox_left {
      margin-top: 47px;
      width: 95vw;
      display: block;
      .certer {
        margin-left: 5px;
        ::v-deep .el-form-item {
          .el-form-item__content {
            width: 90vw;
          }
        }
      }
      .Draftbox_rist {
        width: 95vw;
      }
    }
  }

  .Draftbox_rist_bottom {
    width: 100%;
    margin-top: 10px;

    ::v-deep .el-form-item {
      .el-form-item__content {
        width: 90%;
      }
    }
  }
}
</style>
<style scoped>
.el-form-item >>> .el-form-item__content .el-textarea .el-textarea__inner {
  overflow: hidden;
  resize: none !important;
}
>>> .toolbar {
  border: 1px solid #ccc;
  flex-wrap: wrap;
}
</style>
